import httpClient from '@/api/http-client'
import { makeDMSConfig as makeConfig } from '@/api/http-client'
const urlPrefix = '/contacts/v1'

export { httpClient, urlPrefix, makeConfig }



// WEBPACK FOOTER //
// ./src/apps/crm/contacts/api/data.js